import { useState } from "react";
import { motion } from "framer-motion";
import { toast } from "sonner";
import api from "../lib/api";
import CatMascot from "../components/CatMascot";
import { Button } from "../components/ui/button";
import { FaDiscord } from "react-icons/fa";

export default function Login() {
  const [busy, setBusy] = useState(false);

  const discordLogin = async () => {
    setBusy(true);
    try {
      const res = await api.get("/auth/discord/url");
      window.location.href = res.data.url;
    } catch (e) {
      toast.error("Could not start Discord sign-in");
      setBusy(false);
    }
  };

  return (
    <div className="relative flex min-h-screen items-center justify-center overflow-hidden bg-[#0A0C10] grid-bg px-4">
      <div className="pointer-events-none absolute -top-40 left-1/2 h-96 w-96 -translate-x-1/2 rounded-full bg-purple-700/20 blur-[120px]" />
      <div className="pointer-events-none absolute bottom-0 right-0 h-96 w-96 rounded-full bg-indigo-700/20 blur-[120px]" />
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="card-glass relative z-10 w-full max-w-md rounded-3xl p-8 shadow-2xl"
      >
        <div className="flex flex-col items-center text-center">
          <motion.div animate={{ y: [0, -8, 0] }} transition={{ repeat: Infinity, duration: 3 }} className="relative">
            <div className="absolute inset-0 rounded-full bg-purple-600/40 blur-2xl" />
            <CatMascot size={88} />
          </motion.div>
          <h1 className="mt-5 font-display text-4xl font-black tracking-tight text-white">GG's Kingdom</h1>
          <p className="mt-1 font-mono text-xs uppercase tracking-[0.25em] text-purple-400">Staff Management System</p>
          <p className="mt-4 text-sm text-slate-400">Sign in with Discord to enter the Kingdom. Staff get full access, everyone else joins as a community member.</p>

          <Button
            data-testid="discord-login-btn"
            onClick={discordLogin}
            disabled={busy}
            className="mt-8 h-12 w-full gap-3 rounded-xl bg-[#5865F2] text-base font-semibold text-white transition-all hover:bg-[#4752c4] hover:shadow-[0_0_24px_rgba(88,101,242,0.5)]"
          >
            <FaDiscord className="text-xl" /> Continue with Discord
          </Button>
        </div>
      </motion.div>
    </div>
  );
}
